<template>
  <div class="modal-header" :class="className">
    <BaseContainer>
      <div class="modal-header__wrapper">
        <BaseButton class="modal-header__link" v-if="linkHref" variant="primary" rounded="full">
          <BaseIcon class="desktop" color="secondary" name="arrow_back" size="24"></BaseIcon>
          <BaseIcon class="mobile" color="secondary" name="close" size="18"></BaseIcon>
        </BaseButton>
        <div class="modal-header__inner">
          <h1 class="modal-header__text">
            <slot></slot>
          </h1>
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'PageHeaderModal',
  components: { BaseContainer, BaseButton, BaseIcon },
  props: {
    linkHref: {
      type: String,
      default: null
    },
    linkText: {
      type: String,
      default: null
    },
    linkBaseIcon: {
      type: String,
      default: 'arrow_forward'
    },
    bgTint: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `${(this.bgTint && 'modal-header--tint') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.modal-header {
  @apply bg-white;
}
.modal-header--tint {
  @apply bg-primary-lighter;
}
.modal-header__wrapper {
  @apply py-8 flex flex-row-reverse justify-between;
}
.modal-header__inner {
  @apply flex-1;
}
.modal-header__link {
  @apply m-0 p-0;
}
.modal-header__link .desktop {
  @apply hidden;
}
.modal-header__link .mobile {
  @apply block;
}

@screen md {
  .modal-header__wrapper {
    @apply py-12;
  }
}
@screen lg {
  .modal-header__link {
    @apply mx-4 w-2/12;
  }
  .modal-header__link .desktop {
    @apply block;
  }
  .modal-header__link .mobile {
    @apply hidden;
  }
  .modal-header__wrapper {
    @apply -mx-4 flex-row w-auto;
  }
  .modal-header__inner {
    @apply flex-none w-10/12 px-4 ml-auto;
  }
}
</style>

